// extracted by mini-css-extract-plugin
export default {"principal":"Principal_principal__TXeDT","menus":"Principal_menus__Qc8Ai","exibicao":"Principal_exibicao__0ZUit"};